<script setup lang="ts">
interface IconStatisticProps {
  fill?: string;
}
const props = withDefaults(defineProps<IconStatisticProps>(), {
  fill: "var(--base-secondary-color)",
});
</script>

<template>
  <svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <clipPath id="x56t30a9qa">
        <path d="M1440 0v2334H0V0h1440z" />
      </clipPath>
      <clipPath id="m71wc7n0tb">
        <path d="M12 10.855V12H0v-1.145h12zM3.2 3.75v6H.8v-6h2.4zm8-3.75v9.75H8.8V0h2.4zm-4 1.5v8.25H4.8V1.5h2.4z" />
      </clipPath>
    </defs>
    <g clip-path="url(#x56t30a9qa)" transform="translate(-308 -1669)">
      <g clip-path="url(#m71wc7n0tb)" transform="translate(308 1669)">
        <path :fill="props.fill" d="M0 0h12v12H0V0z" />
      </g>
    </g>
  </svg>
</template>
